<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت گروه‌های افراد</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">گروه افراد</label>
          <input
              type="text"
              class="form-control"
              placeholder="گروه افراد را وارد کنید"
              v-model="newItem.groups"
          />
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">میزان ارتباط</label>
          <select class="form-select" v-model="newItem.communication_amount">
            <option value="" disabled>میزان ارتباط را انتخاب کنید</option>
            <option v-for="(communication_amount, index) in communication_amounts" :key="index" :value="communication_amount">
              {{ communication_amount }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['گروه افراد', 'میزان ارتباط']"
          :fields="['groups', 'communication_amount']"
          :items="peopleGroups"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش گروه افراد"
          modal-id="peopleGroupModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">گروه افراد</label>
            <input
                type="text"
                class="form-control"
                placeholder="گروه افراد را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.groups"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">میزان ارتباط</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.communication_amount">
              <option value="" disabled>میزان ارتباط را انتخاب کنید</option>
              <option v-for="(communication_amount, index) in communication_amounts" :key="index" :value="communication_amount">
                {{ communication_amount }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  groups: '',
  communication_amount: ''
};
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/people-groups/index',
      afterMutation: 'communicationDomain/setPeopleGroups'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      communication_amounts: ['خیلی زیاد', 'زیاد', 'متوسط', 'کم', 'خیلی کم'],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    peopleGroups: {
      get() {
        return this.$store.state.communicationDomain.peopleGroups;
      },
      set(value) {
        this.$store.commit("communicationDomain/setPeopleGroups", value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.newItem.groups || !this.newItem.communication_amount) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/people-groups/store',
      })

      this.peopleGroups = [...this.peopleGroups, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeItem(index) {
      const peopleGroup = this.peopleGroups.find((_, i) => i === index);
      this.peopleGroups = this.peopleGroups.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: peopleGroup.id,
        endpoint: '/people-groups/delete',
      })
    },
    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('peopleGroupModalId'));
      modal.show();
    },
    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedItem.groups || !this.editedItem.communication_amount) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.peopleGroups.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/people-groups/update',
      })

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('peopleGroupModalId'));
      modal.hide();
    }
  }
};
</script>
